var map = {
	"./BR.png": "16c0",
	"./BR2.png": "9f99",
	"./BTC.png": "308d",
	"./EUA.png": "1e36",
	"./EUA2.png": "c7cf",
	"./GOLD.png": "4db7",
	"./OIL.png": "0ecc",
	"./SA.png": "f00b",
	"./UK.png": "58bd",
	"./UKG.png": "f6e9",
	"./blueToken.png": "5b3c",
	"./tesla.png": "4c06"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4ef1";